export const DUO_CLI_APP_NAME = 'Duo CLI';

export const DUO_CLI_APP_VENDOR = 'GitLab';

/**
 * Version boundary for Duo CLI gating: at/above this the backend enforces gating
 * (header-based); below it the CLI falls back to the client-side experimental-feature gate.
 */
export const MINIMUM_GITLAB_VERSION = '19.2.0';

/** Keep the literal `/feedback` substring so the user can report the bug. */
export const buildFatalErrorMessage = (errorMessage: string): string =>
  `GitLab Duo CLI encountered an unexpected error and had to close.\n\n${errorMessage}\n\nPlease start a new session and run /feedback to report this bug.`;
